import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { ResearchCategory } from "@/constants/terminal/research-category"

export const Route = createFileRoute("/_admin/admin/monitoring_/$companyRunId")(
  {
    validateSearch: z.object({
      monitoringRunId: z.string().uuid().optional(),
      category: z.nativeEnum(ResearchCategory).optional(),
      researchTaskId: z.string().uuid().optional(),
      tab: z.enum(["research", "file"]).default("research"),
    }),
    beforeLoad: ({ params, search }) => {
      throw redirect({
        to: "/terminal/admin/$companyRunId",
        params,
        search,
        replace: true,
      })
    },
  }
)
